// import request from '@/utils/request'
import {api} from "@/api";

// 查询画面列表
export function listData(query) {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/ztgl/hmgl/list',
        method: 'get',
        params: query
    })
}

// 画面名称
export function updateData(data) {
    // debugger;
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/ztgl/hmgl',
        method: 'post',
        data: data
    })
}

// 新增画面
export function addData(data) {
    // debugger;
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/ztgl/hmgl',
        method: 'post',
        data: data
    })
}

//查询画面基础信息
export function selectStageById(stageId) {
    // debugger;
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: 'ztgl/hmgl/vueSelectStageById',
        method: 'post',
        data: {"stageId": stageId}
    })
}

//删除画面
export function delData(stageId) {
    // debugger;
    return api({
        // headers: {
        //     "authorization": "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImQxNGQ5MTVjLTZlNzEtNDZjMy1hNDMwLTlhZWMyNzYxYjg2YyJ9.nqJnnYMpVgODgMlIaxrvtH8AXzXXBmqgA65ITIxOi-mckyPFeYwW6FnzDAxqoAdrW92kEgEXn44Pq9hD2oVz7A"
        // },
        url: 'ztgl/hmgl/stageDeleteById',
        method: 'post',
        data: {"stageId": stageId}
    })
}

// 获取项目树
export function getZtTree(data) {
    // debugger;
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization')
        },
        url: '/zouk/rest/project/getZtTree',
        method: 'post',
        data: data
    })
}


//获取wss地址
export function getWsUrlApi(data) {
    // debugger;
    return api({
        headers: {
            "authorization": "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImQxNGQ5MTVjLTZlNzEtNDZjMy1hNDMwLTlhZWMyNzYxYjg2YyJ9.nqJnnYMpVgODgMlIaxrvtH8AXzXXBmqgA65ITIxOi-mckyPFeYwW6FnzDAxqoAdrW92kEgEXn44Pq9hD2oVz7A"
        },
        url: '/zouk/rest/config/getWsUrl',
        method: 'post',
        data: data
    })
}
